import Script from "next/script"
import { useRegionCode } from "modules/i18n/hooks/useRegionCode"
import { RegionCode } from "modules/i18n/config/region"

const ECHOBOX_ENABLED_REGIONS = [RegionCode.Uk, RegionCode.Au]

/**
 * Echobox web tag for TC-UK and TC-AU. Loads after page is interactive to ensure
 * canonical tags are present in the DOM before the script runs.
 */
export const Echobox = () => {
  const regionCode = useRegionCode()

  const isEnabled = ECHOBOX_ENABLED_REGIONS.includes(regionCode)

  return isEnabled ? (
    <Script async id="ebx" src="//applets.ebxcdn.com/ebx.js" strategy="afterInteractive" />
  ) : null
}
